<template>
	<a href="/basket" class="basket_link"><span>Basket</span><i class="fal fa-fw fa-shopping-basket" v-bind:class="{ hasitems: this.working_count > 0 }" :data-count="this.working_count"></i></a>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
	props: [
		'count'
	],

	computed: {
		...mapGetters({
			refreshStatus: 'getMinicartRefreshStatus'
		})
	},
  
	data: () => {
		return {
			'working_count' : 0,
		}
	},

	watch: {
		refreshStatus: function(value) {
			if (value==true) {
				this.$store.commit('updateMinicartRefreshStatus', false);
				this.getBasketSummary();
			}
		},
	},

	mounted() {
		this.working_count = this.count;
	},

	methods: {
		getBasketSummary: function() {
			axios.get('/box/basket/summary')
			.then(response => {
				this.working_count = response.data.count;
			})
			.catch(error => {
			});
		}
	}
};
</script>